'use client';

import { todayInArgentina, useNextAvailable } from '@contexts/next-available';

const formatShortDate = (date) =>
  new Date(`${date}T12:00:00`).toLocaleDateString('es-AR', { weekday: 'short', day: 'numeric', month: 'short' });

/** «Turnos hoy» o «Próximo turno: jue 15 oct». Mientras carga ocupa su lugar, sin saltos. */
export default function NextAvailable({ username, className = '' }) {
  const date = useNextAvailable(username);
  if (date === undefined) return <span className={`next-available is-loading ${className}`} aria-hidden="true" />;
  if (!date) return null;
  const today = date <= todayInArgentina();
  return (
    <span className={`next-available ${today ? 'is-today' : ''} ${className}`}>
      {today ? 'Turnos hoy' : `Próximo turno: ${formatShortDate(date)}`}
    </span>
  );
}
